import { borderRadiusSm, COLORS } from 'assets/styled';
import { respondTo } from 'assets/styled/breakpoints';
import styled, { css } from 'styled-components';

interface StyledProps {
  isActive: boolean;
}

export const Container = styled.div`
  display: flex;
  flex-direction: column;
`;

export const Card = styled.div`
  background-color: ${COLORS.WHITE};
  border-radius: ${borderRadiusSm};
  padding: 30rem;

  ${respondTo.bigPhone`
    padding: 15rem;
  `}
`;

export const ShippingWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 20rem;
`;

export const ShippingTitleWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 20rem;
`;

export const ShippingTypesWrapper = styled.div`
  display: flex;
  align-items: center;
  gap: 20rem;
`;

export const ShippingTypeItem = styled.div`
  display: flex;
  align-items: center;
  gap: 10rem;
  cursor: pointer;
  border-radius: 5rem;
  padding: 5rem 10rem;
  transition: 0.3s ease;

  ${(props: StyledProps) =>
    props.isActive &&
    css`
      color: ${COLORS.STRICT_WHITE};
      background-color: ${COLORS.GREEN};

      ${ShippingTypeName} {
        color: ${COLORS.STRICT_WHITE};
      }
    `}
`;

export const ShippingTypeName = styled.span`
  font-size: 16rem;
  font-weight: 400;
  color: ${COLORS.BLACK};
  transition: 0.3s ease;
`;

export const ShippingAddress = styled.div`
  width: 100%;
  max-width: 100%;
  display: flex;
  flex-wrap: wrap;
  gap: 3%;
  align-items: stretch;
  border-bottom: 1px solid ${COLORS.BORDER};

  ${respondTo.bigTablet`
    flex-direction: column;
  `}
`;

export const DeliveryDateWrapper = styled.div`
  display: flex;
  flex-direction: column;
  max-width: 100%;
  width: 100%;
  gap: 20rem;
  padding: 30rem 0;
  border-bottom: 1px solid ${COLORS.BORDER};
`;

export const SectionTitle = styled.span`
  display: block;
  font-size: 30rem;
  font-weight: 400;
  color: ${COLORS.BLACK};

  ${respondTo.smallTablet`
    font-size: 24rem;
  `}

  ${respondTo.bigPhone`
    font-size: 22rem;
  `}
`;

export const SectionTitleWrapper = styled.div`
  display: flex;
  align-items: flex-start;
  gap: 5rem;
`;

export const OrderReference = styled.div`
  display: flex;
  flex-direction: column;
  max-width: 100%;
  width: 100%;
  gap: 20rem;
  padding: 30rem 0;
`;

export const PickupInfoNote = styled.span`
  font-size: 16rem;
  color: ${COLORS.BLACK};
  display: block;
  margin-bottom: 30rem;
`;

export const PickupAddress = styled.span`
  display: block;
  font-size: 16rem;
  color: ${COLORS.GREEN};
  margin-bottom: 30rem;
`;

export const AdditionalCartDetails = styled.div`
  display: flex;
  flex-direction: column;
  max-width: 100%;
  width: 100%;
  gap: 20rem;
  padding: 30rem 0;
  border-top: 1px solid ${COLORS.BORDER};
`;

export const AdditionalCartDetailsTitle = styled.span`
  font-size: 20rem;
  font-weight: bold;
  color: ${COLORS.BLACK};
  display: block;
`;

export const AdditionalCartDetailsContent = styled.span`
  font-size: 18rem;
  font-weight: 300;
  color: ${COLORS.BLACK};
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 4;
  overflow: hidden;
  text-overflow: ellipsis;
  overflow-wrap: anywhere;
  word-break: break-word;
  margin-top: 10rem;
`;
